module.exports = __webpack_public_path__ + "static/media/customer-family.2f8eafbc.jpg";